import { render, staticRenderFns } from "./SaveTableViewDialog.vue?vue&type=template&id=67df559c&lang=pug&"
import script from "./SaveTableViewDialog.vue?vue&type=script&lang=ts&"
export * from "./SaveTableViewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports